import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from "../../views/authentication/authentication.service";


@Injectable()
export class WelcomeService {

  constructor(private http: HttpClient,  private authService: AuthenticationService) {
  }


  saveEmail(change: any) : Observable<any>  {

    return this.http.post(environment.API + '/aF/contact/',change)
  }

  savings() : Observable<any> {

    return this.http.get(environment.AdditionalFeatAPI + '/aF/savings/')
    
  }

  analyzed() : Observable<any> {

    return this.http.get(environment.AdditionalFeatAPI + '/aF/analyzed/')
    
  }

  lines() : Observable<any> {

    return this.http.get(environment.AdditionalFeatAPI + '/aF/lines-quantity/')
    
  }

  accounts() : Observable<any> {

    return this.http.get(environment.AdditionalFeatAPI + '/aF/master-accounts/')

  }



}



// WEBPACK FOOTER //
// ./src/app/views/welcome/welcome.service.ts